import { render } from "./CompanyBoard.vue?vue&type=template&id=5c74f27b&ts=true"
import script from "./CompanyBoard.vue?vue&type=script&lang=ts"
export * from "./CompanyBoard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__